import cx from 'classnames'
import { useState } from 'react'
import Container from 'react-bootstrap/Container'

import Icon from '../../../../components/Icon/Icon'
import Typography from '../../../../components/Typography/Typography'
import UserMenuBar from '../UserMenuBar/UserMenuBar'

import './MobileMenuBar.scss'

const MobileMenuBar = ({
    loading,
    logout,
    isClubMember,
    ticketsRef,
    cinestarClubRef,
    lostCardRef,
    contactInfoRef,
    changePassRef,
    isSticky,
}) => {
    const [isOpen, setIsOpen] = useState(false)

    const onCloseHandler = () => {
        setIsOpen(false)
    }

    const color = isClubMember ? 'purple' : 'blue'

    return (
        <Container
            fluid
            className={cx(
                `mobile-menu-bar mobile-menu-bar--${color} position-relative`,
                isSticky && 'fixed-on-top start-0 end-0'
            )}
        >
            <Container
                fluid
                className="d-flex justify-content-between align-items-center p-3"
                onClick={() => setIsOpen((prevState) => !prevState)}
            >
                <Typography variant={'p'}>Menu</Typography>
                <Icon name={isOpen ? 'chevron–up' : 'chevron–down'} role={'button'} />
            </Container>
            {isOpen && (
                <UserMenuBar
                    logout={logout}
                    loading={loading}
                    isClubMember={isClubMember}
                    ticketsRef={ticketsRef}
                    cinestarClubRef={cinestarClubRef}
                    lostCardRef={lostCardRef}
                    contactInfoRef={contactInfoRef}
                    changePassRef={changePassRef}
                    className={'position-absolute p-3'}
                    color={color}
                    onClick={onCloseHandler}
                />
            )}
        </Container>
    )
}

export default MobileMenuBar
